<template>
  <div class="fshr-tripServices" v-if="tripServices.length">
    <div
      v-for="tripService in tripServices"
      :key="tripService.id"
      class="fshr-tripServices__item"
      :class="[
        tripService.id &&
          `fshr-tripServices__item--${tripService.id.toLowerCase()}`,
        tripService.is_highlighted && `fshr-tripServices__item--highlighted`,
      ]"
      v-tooltip="getBasicTooltip(tripService.tooltip)"
    >
      <i
        v-if="tripService.hasOwnProperty('icon') && tripService.icon !== null"
        class="fshr-tripServices__icon"
        :class="tripService.icon"
      />
      <img
        v-if="tripService.id === 'SKIPARTNERGOLD'"
        :src="serverurl + 'Content/images/stit_gold.png'"
        class="fshr-tripServices__img"
      />
      <img
        v-if="tripService.id === 'SKIPARTNERSILVER'"
        :src="serverurl + 'Content/images/stit_silver.png'"
        class="fshr-tripServices__img"
      />
      <img
        v-if="tripService.id === 'SKIPARTNERBASIC'"
        :src="serverurl + 'Content/images/ski_partner_basic.png'"
        class="fshr-tripServices__img"
      />
      <img
        v-if="tripService.id === 'SUNPARTNERGOLD'"
        :src="serverurl + 'Content/images/stit_gold_sun.png'"
        class="fshr-tripServices__img"
      />
      <img
        v-if="tripService.id === 'SUNPARTNERSILVER'"
        :src="serverurl + 'Content/images/stit_silver_sun.png'"
        class="fshr-tripServices__img"
      />
      <img
        v-if="tripService.id === 'SUNPARTNERBASIC'"
        :src="serverurl + 'Content/images/ski_partner_basic_sun.png'"
        class="fshr-tripServices__img"
      />
      <div class="fshr-tripServices__label">
        {{ tripService.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "trip-services",
  props: {
    tripServices: {
      type: Array,
      required: false,
      default: () => [],
    },
    serverurl: {
      required: false,
      type: String,
      default: "http://localhost/",
    },
  },
};
</script>
